<script lang="ts" setup>
import { $fetch } from '@/home/plugins/fetch';
import InfoCard from '@/home/components/InfoCard.vue';
import NumberCard from './NumberCard.vue';
import { useAsyncData } from '@/home/hooks/async-data';

const { data: security } = useAsyncData('about:security', () => $fetch('/committee/member/v1/list', { data: { committeeType: 3 } }))
</script>

<template>
  <section class="page-about-security-commitee pt-48px">
    <div class="about-security-commitee-container container pb-48px">
      <h2 class="m-0 text-center text-32px font-medium">{{ $t('about.organizationStructure.structure3.title') }}</h2>

      <InfoCard class="structure-box mt-32px" :title="$t('about.organizationStructure.structure3.title')">
        <p class="m-0 text-16px leading-24px">{{ $t('about.securityCommitee.description') }}</p>
        <ul class="mx-0 mb-0 mt-16px flex flex-wrap list-none p-0">
          <li class="w-25%">
            <NumberCard number="1">{{ $t('about.securityCommitee.duty1') }}</NumberCard>
          </li>
          <li class="w-25%">
            <NumberCard number="2">{{ $t('about.securityCommitee.duty2') }}</NumberCard>
          </li>
          <li class="w-25%">
            <NumberCard number="3">{{ $t('about.securityCommitee.duty3') }}</NumberCard>
          </li>
          <li class="w-25%">
            <NumberCard number="4">{{ $t('about.securityCommitee.duty4') }}</NumberCard>
          </li>
          <li class="w-25%">
            <NumberCard number="5">{{ $t('about.securityCommitee.duty5') }}</NumberCard>
          </li>
          <li class="w-25%">
            <NumberCard number="6">{{ $t('about.securityCommitee.duty6') }}</NumberCard>
          </li>
          <li class="w-25%">
            <NumberCard number="7">{{ $t('about.securityCommitee.duty7') }}</NumberCard>
          </li>
          <li class="w-25%">
            <NumberCard number="8">{{ $t('about.securityCommitee.duty8') }}</NumberCard>
          </li>
        </ul>
      </InfoCard>

      <ul class="contributors m-0 flex flex-shrink flex-wrap list-none p-0">
        <li v-for="item in security" :key="item.id">
          <img class="lazyload" :data-src="item.photo" :alt="item.name" :title="item.name">
        </li>
      </ul>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.page-about-security-commitee {
  .structure-box {
    ul {
      li {
        &:nth-child(n+5) {
          margin-top: 32px;
        }
      }
    }
  }

  .contributors {
    margin-top: 48px;

    li {
      width: 213px;
      height: 78px;
      margin-left: 16px;
      background-color: #fff;

      &:nth-child(n+7) {
        margin-top: 16px;
      }

      &:nth-child(6n+1) {
        margin-left: 0;
      }

      &:hover {
        img {
          width: 110%;
          height: 110%;
          margin-top: -2%;
          margin-left: -5%;
        }
      }

      img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: all 0.3s;
      }
    }
  }
}
</style>
